<app-inner-box>
  <app-subpage-header title="Mindesthaltbarkeit"></app-subpage-header>
  <br>
  <app-mhd-list />
</app-inner-box>
